"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USW_COMPONENT_TYPES = exports.STATIC_URL = exports.SSR_DATA = exports.PAX_TRANSLATION_KEYS = exports.LOCATION_TYPES = exports.JWT_HASH = exports.IGNORE_CACHE = exports.ICONS = exports.GOOGLE_ADS_DATA = exports.ENVIRONMENT = exports.DEFAULT_ROOM_OCCUPANCY = exports.DEFAULT_ENDPOINT = exports.DEFAULT_CONTEXTUAL_PRODUCT_ID = exports.CONFIGS = exports.BANNER_DATA_1 = exports.BANNER_DATA = exports.ASYNC_DATA_KEYS = exports.AGE_LIST_DEFAULT = void 0;
var USW_COMPONENT_TYPES = {
  HERO_BANNER: 'heroBanner',
  PLACEPICKER: 'placepicker',
  DATEPICKER: 'datepicker',
  MULTI_ROOM_SELECT: 'multi_room_select',
  PAX_COUNTER: 'passenger_counter',
  DROPDOWN: 'dropdown',
  LINK: 'link',
  CHECKBOX: 'checkbox',
  BUTTON: 'button',
  BOTTOM_BANNER: 'bottomBanner'
};
exports.USW_COMPONENT_TYPES = USW_COMPONENT_TYPES;
var LOCATION_TYPES = {
  AIR_PORT: 'airport',
  REGION: 'region',
  CITY: 'city',
  LANDMARK: 'landmark',
  NEIGHBORHOOD: 'neighborhood',
  HOTEL: 'hotel'
};
exports.LOCATION_TYPES = LOCATION_TYPES;
var ICONS = {
  FLIGHT_ICON: 'FlightIcon',
  LOCATION_ICON: 'LocationOnIcon'
};
exports.ICONS = ICONS;
var PAX_TRANSLATION_KEYS = {
  ADULT: 'adultSingle',
  ADULT_AGE_LIMIT: 'adultAgeLimit',
  CHILD: 'childSingle',
  CHILD_AGE_LIMIT: 'childAgeLimit',
  INFANT: 'infantSingle',
  INFANT_AGE_LIMIT: 'infantAgeLimit'
};
exports.PAX_TRANSLATION_KEYS = PAX_TRANSLATION_KEYS;
var ENVIRONMENT = {
  DEVELOPMENT: 'DEVELOPMENT',
  PRE_PRODUCTION: 'PRE_PRODUCTION',
  PRODUCTION: 'PRODUCTION',
  STAGING: 'STAGING'
};
exports.ENVIRONMENT = ENVIRONMENT;
var ASYNC_DATA_KEYS = {
  FEATURE_FLAG: 'feature_flag',
  ORIGIN_STATIONS: 'originStationsData',
  SEARCH_DEEP_LINK: 'searchDeepLink',
  DATA_VISOR: 'dataVisor',
  NEAREST_AIRPORT: 'nearest_airport',
  DESTINATION_STATIONS: 'destination_stations',
  BASE_CURRENCY: 'baseCurrency',
  CALENDAR_DATA: 'calendarDateFormatData'
};
exports.ASYNC_DATA_KEYS = ASYNC_DATA_KEYS;
var SSR_DATA = {
  synonyms: [{
    name: 'ALGO_ONE',
    value: ['SSI5', 'SPAK', 'SMD7', 'SKLB', 'SXAI']
  }, {
    name: 'ALGO_TWO',
    value: ['SRX5', 'SRDJ', 'SLAK', 'SKD7', 'SBZ2']
  }, {
    name: 'ALGO_THREE',
    value: ['SPGR', 'SMDJ', 'SMXT', 'SZQZ', 'SLXT']
  }, {
    name: 'ALGO_FOUR',
    value: ['SSXT', 'SLZ2', 'SRXT', 'SAI5', 'SBI5']
  }, {
    name: 'ALGO_FIVE',
    value: ['SLD7', 'SQXJ', 'SOXT', 'SBFD', 'SYXT']
  }, {
    name: 'ALGO_SIX',
    value: ['SLUM', 'SQAI', 'SORM', 'SBOH', 'SYAM']
  }],
  api_data: [{
    source: 'booking',
    id: 'sdlkd2l3'
  }, {
    source: 'details',
    id: 'eue3kds'
  }, {
    source: 'checkout',
    id: 'wxesdumi'
  }, {
    source: 'search',
    id: 'xmncx278'
  }, {
    source: 'smartfill',
    id: 'wiuwejk2'
  }]
};
exports.SSR_DATA = SSR_DATA;
var JWT_HASH = '906a14a4c039ea4af65874742638ddae5c3ec9c6bbc9026eea35f00f';
exports.JWT_HASH = JWT_HASH;
var DEFAULT_ENDPOINT = 'smartfill';
exports.DEFAULT_ENDPOINT = DEFAULT_ENDPOINT;
var DEFAULT_CONTEXTUAL_PRODUCT_ID = 'hotels';
exports.DEFAULT_CONTEXTUAL_PRODUCT_ID = DEFAULT_CONTEXTUAL_PRODUCT_ID;
var DEFAULT_ROOM_OCCUPANCY = [{
  adult: 1,
  child: 0,
  infant: 0
}];
exports.DEFAULT_ROOM_OCCUPANCY = DEFAULT_ROOM_OCCUPANCY;
var AGE_LIST_DEFAULT = [{
  label: 'Under 1',
  value: 0
}, {
  label: 1,
  value: 1
}, {
  label: 2,
  value: 2
}, {
  label: 3,
  value: 3
}, {
  label: 4,
  value: 4
}, {
  label: 5,
  value: 5
}, {
  label: 6,
  value: 6
}, {
  label: 7,
  value: 7
}, {
  label: 8,
  value: 8
}, {
  label: 9,
  value: 9
}, {
  label: 10,
  value: 10
}, {
  label: 11,
  value: 11
}, {
  label: 12,
  value: 12
}, {
  label: 13,
  value: 13
}, {
  label: 14,
  value: 14
}, {
  label: 15,
  value: 15
}, {
  label: 16,
  value: 16
}, {
  label: 17,
  value: 17
}];
exports.AGE_LIST_DEFAULT = AGE_LIST_DEFAULT;
var BANNER_DATA = {
  type: 'bottomBanner',
  id: 'bottomBanner',
  imageURL: 'https://a.staticaa.com/images/campaign/hero-banner/INTHISTOGETHER_HEROBANNER_21Apr2020.jpg',
  headline: 'This is a Banner Headline',
  subheadline: 'This is a Banner SubHeadline',
  headlineColor: 'tertiaryLight',
  subheadlineColor: 'tertiaryLight',
  buttonText: 'AirAsia.com Website',
  buttonUrl: 'https://www.airasia.com/',
  redirectUrl: 'https://www.airasia.com/',
  showBanner: 'TRUE'
};
exports.BANNER_DATA = BANNER_DATA;
var BANNER_DATA_1 = {
  showBanner: 'TRUE',
  imageURL: 'https://static.airasia.com/hotels/search-widget-banner/Desktop_MY_Hotel_banner.jpg',
  redirectUrl: 'https://www.airasia.com/hotels/en/gb/?locationId=601371&checkin=2021-11-16&checkout=2021-11-17&adults=2',
  headline: '',
  subheadline: '',
  headlineColor: '',
  subheadlineColor: '',
  buttonText: '',
  buttonUrl: ''
};
exports.BANNER_DATA_1 = BANNER_DATA_1;
var GOOGLE_ADS_DATA = {
  HSW: {
    BANNER_AD_ID: 'div-gpt-ad-1685942111172-0',
    DEFINE_SLOT: '/10025506/AirAsia.com/hotels/Hotels_Homepage_Standrad'
  }
};
exports.GOOGLE_ADS_DATA = GOOGLE_ADS_DATA;
var CONFIGS = {
  ENABLE_REBRANDING_HOTEL_WEB: 'ENABLE_REBRANDING_HOTEL_WEB'
};
exports.CONFIGS = CONFIGS;
var IGNORE_CACHE = 'ignoreCache=1';
exports.IGNORE_CACHE = IGNORE_CACHE;
var STATIC_URL = {
  STAGING: 'https://static.stgairasia.com',
  PRODUCTION: 'https://static.airasia.com'
};
exports.STATIC_URL = STATIC_URL;